// SiteUp (#81): modos do agente de IA POR INBOX. Fonte única de verdade no front
// — espelha Captain::Assistant::AI_MODES no backend. 5 perfis:
//  off                → IA desligada
//  suggest_manual     → atendente clica p/ a IA gerar o rascunho
//  suggest_auto       → IA gera o rascunho sozinha a cada msg do lead (não envia)
//  autonomous         → IA responde sozinha, SEM oferecer sugestão
//  autonomous_suggest → IA responde sozinha E oferece sugestão ao atendente
export const AI_AGENT_MODES = [
  'off',
  'suggest_manual',
  'suggest_auto',
  'autonomous',
  'autonomous_suggest',
];

// Opções (valor + rótulo) do seletor "Modo da IA por caixa". Mantidas aqui, ao
// lado de AI_AGENT_MODES, para o seletor não duplicar/derivar a lista por conta
// própria (evita drift quando o backend Captain::Assistant::AI_MODES muda). A
// ordem espelha AI_AGENT_MODES.
export const AI_AGENT_MODE_OPTIONS = [
  {
    value: 'off',
    label: 'Desligada',
    description: 'Não faz nada nesta caixa.',
  },
  {
    value: 'suggest_manual',
    label: 'Só quando pedirem',
    description:
      'Só escreve um rascunho quando o atendente clica em "Sugerir resposta". Nada sai sozinho.',
  },
  {
    value: 'suggest_auto',
    label: 'Sugere a cada mensagem',
    description:
      'Deixa um rascunho pronto a cada mensagem do cliente; quem envia é o atendente.',
  },
  {
    value: 'autonomous',
    label: 'Responde sozinha',
    description:
      'Envia a resposta ao cliente sem esperar ninguém; não oferece rascunho ao atendente.',
  },
  {
    value: 'autonomous_suggest',
    label: 'Responde e ainda sugere',
    description:
      'Envia sozinha e, quando o atendente assume a conversa, deixa rascunhos para ele.',
  },
];

// Descrição amigável de um modo (para help dinâmico no seletor).
export const aiAgentModeDescription = value =>
  AI_AGENT_MODE_OPTIONS.find(o => o.value === value)?.description || '';

// Modo padrão (espelha Captain::Assistant::DEFAULT_AI_MODE): preserva o
// comportamento histórico de quem já estava autônomo com sugestão.
export const DEFAULT_AI_AGENT_MODE = 'autonomous_suggest';

// Perfis em que a IA atende sozinha → mostram o indicador "IA ativa/pausada" e o
// toggle Pausar/Devolver na barra do editor.
export const AUTONOMOUS_MODES = ['autonomous', 'autonomous_suggest'];

// Perfis em que o atendente pode pedir uma sugestão ("Sugerir resposta" no menu ✨
// e o card de sugestão acima do editor).
export const SUGGEST_MODES = [
  'suggest_manual',
  'suggest_auto',
  'autonomous_suggest',
];

// Resolve o modo da conversa: respeita o override por-conversa
// (additional_attributes.ai_agent.mode) quando é um perfil canônico; senão usa o
// ai_agent_mode FRESCO do show da conversa (config POR INBOX). Mantém compat com o
// estado legado por-conversa ({active}/{mode:'suggest'}). Retorna null sem agente.
export function resolveAiAgentMode(chat) {
  const settings = chat?.additional_attributes?.ai_agent || {};
  const raw = settings.mode;
  const configured = chat?.ai_agent_mode;
  if (configured === 'off') return 'off';
  if (AUTONOMOUS_MODES.includes(raw) && AUTONOMOUS_MODES.includes(configured)) {
    return configured;
  }
  if (AI_AGENT_MODES.includes(raw)) return raw;
  if (settings.active === false) return 'off';
  if (raw === 'suggest' || settings.active === true) return 'suggest_auto';
  return configured || null;
}

// Há agente Captain ativo nesta conversa (qualquer perfil ≠ off)?
export function hasActiveAiAgent(chat) {
  const mode = resolveAiAgentMode(chat);
  return Boolean(mode) && mode !== 'off';
}

// A IA atende sozinha neste modo (autonomous ou autonomous_suggest)?
export function isAutonomousMode(mode) {
  return AUTONOMOUS_MODES.includes(mode);
}

// O atendente pode pedir uma sugestão nesta conversa?
export function canSuggestForChat(chat) {
  return SUGGEST_MODES.includes(resolveAiAgentMode(chat));
}
